(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-chart"]) return;
  try {
    
jQuery(document).ready(function(){

jQuery('#tabs li a').click(function(){
    var t = jQuery(this).attr('id');
  if(!jQuery(this).hasClass('active')){ //this is the start of our condition 
    jQuery('#tabs li a').removeClass('active');           
    jQuery(this).addClass('active');
    
    jQuery('.sizing-container').removeClass('active');
    jQuery('#'+ t + 'C').addClass('active');
 }
});
  });


  } catch(e) { console.error(e); }
})();
})();
